export default __webpack_public_path__ + "static/media/WhiteList.2976ed82.svg";